const { USER_ROLES } = require('./constants');

export function isCardHolder(roleId) {
    return USER_ROLES.CARD_HOLDER === roleId;
}

export function isAdminUser(roleId) {
    return USER_ROLES.ADMIN === roleId;
}

export function isSuperAdminUser(roleId) {
    return USER_ROLES.SUPERADMIN === roleId;
}
